const Function = {
  /**
   * 根据时间戳格式化日期函数
   * @param timestamp  时间戳
   * @param fmt  类型  默认：yyyy-MM-dd hh:mm:ss，（其中的 yyyy | MM | dd | hh | mm | ss 是分别匹配 年 | 月 | 日 | 时 | 分 | 秒 的关键字）
   * 示例：
   *      yyyy年MM月dd -> 2019年09月7日
   *      mm分ss秒 -> 16分53秒
   * @returns {string}
   */
  formatDate(timestamp, fmt = '') {
    fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
    const date = new Date(timestamp * 1000);
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        const str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : this.padLeftZero(str));
      }
    }
    return fmt;
  },

  // 左边补零
  padLeftZero(str) {
    return ('00' + str).substr(str.length);
  },

  // 隐藏页面加载前的loading层/页面过渡
  hiddenLoading() {
    const el_loading_mark = document.querySelector('.el-loading-mask');
    if (el_loading_mark) {
      el_loading_mark.classList.add('display-none');
    }
    const layout_right = document.querySelector('.layout-right');
    if (layout_right) {
      layout_right.classList.add('jm-animate');
      setTimeout(() => {
        layout_right.classList.add('layout-right-show');
      }, 0);
    }
  },

  // 显示页面加载前的loading层
  showLoading() {
    const el_loading_mark = document.querySelector('.el-loading-mask');
    if (el_loading_mark) {
      el_loading_mark.classList.remove('display-none');
    }
    const layout_right = document.querySelector('.layout-right');
    if (layout_right) {
      layout_right.classList.remove('jm-animate');
      setTimeout(() => {
        layout_right.classList.remove('layout-right-show');
      }, 0);
    }
  },

  // blob转为base64
  blobToDataURL(blob, callback) {
    var a = new FileReader();
    a.onload = e => {
      callback(e.target.result);
    };
    a.readAsDataURL(blob);
  },

  // ...other function
};

export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$function', { value: Function });
  }
};
